import { useTranslation } from "react-i18next";
import SEO from "@/components/common/SEO";
import PageHero from "@/components/common/PageHero";

export default function Terms() {
    const { t } = useTranslation();
    return (
        <>
            <SEO title="Terms & Conditions | Exportfy.world" description="Exportfy.world terms and conditions for use of the website and services." path="/terms" />
            <PageHero eyebrow={t("legal.hero.eyebrow")} title={t("legal.hero.title")} subtitle={t("legal.hero.subtitle")} />
            <section className="section-y">
                <div className="container-x max-w-3xl prose prose-slate">
                    <h2 className="text-2xl font-bold text-[#0A2540]">{t("legal.terms.sections.services.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.terms.sections.services.description")}</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.terms.sections.aiStatus.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.terms.sections.aiStatus.description")}</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.terms.sections.testimonials.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.terms.sections.testimonials.description")}</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.terms.sections.jurisdiction.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.terms.sections.jurisdiction.description")}</p>
                    <h2 className="text-2xl font-bold text-[#0A2540] mt-10">{t("legal.terms.sections.contact.title")}</h2>
                    <p className="text-slate-600 mt-3 leading-relaxed">{t("legal.terms.sections.contact.description")} <a className="text-[#1D4ED8] font-semibold" href="mailto:hello@exportfy.world">hello@exportfy.world</a>.</p>
                </div>
            </section>
        </>
    );
}
